import moment from "moment";

export const isTrue = (value) => {
  return value === true || value === "true";
};

export const handleNavigate = (path, hash, navigate) => {
  navigate(path);
  setTimeout(() => {
    const section = document.querySelector(hash);
    if (section) {
      section?.scrollIntoView({ behavior: "smooth" });
    }
  }, 0);
};

// Function to convert HTML to plain text
const stripHtmlAndStyles = (html) => {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
};

// Function to apply character limit without counting HTML tags or styles
export const charLimit = (html, limit) => {
  const plainText = stripHtmlAndStyles(html); // Remove HTML tags and styles
  return plainText?.length > limit
    ? plainText.substring(0, limit + 1) + "..." || "---"
    : plainText;
};

export const createArrayUpto = (number) => {
  return [...Array(number)];
};

export function collectIds(data) {
  const ids = [];

  function traverse(item) {
    if (item && item._id) {
      ids.push(item._id); // Add the current _id to the array
      if (item._parent) {
        traverse(item._parent); // Recursively traverse the parent
      }
    }
  }

  traverse(data?._parent);
  data?.admin?.forEach(element => {
    if (element.role === "ADMIN" && element._user?._id) {
      ids.push(element._user?._id);

    }
  })

  return ids;
}

export const extractedUrlPath = (url) => {
  if (!url || !url.includes(".com/")) return "";
  return url.split(".com/")[1] || "";
};
// below chat section
// //--------in-use-message-list--it-is-check-link-or-text------------------
// export const isLink = (message) => {
//   if (!message) return '';
//   const urlPattern = /(https?:\/\/[^\s]+)/gi;
//   const urlMatch = message.match(urlPattern);

//   if (urlMatch) {
//     return <Microlink
//       url={urlMatch[0]}
//       // size="large"
//       // media="image"
//       // media='logo'
//       target="_blank"
//     />;
//   } else {
//     return <p>{message}</p>;
//   }
// };

// // ---------handle-preview-file-image-or-pdf----in-chat-section------------
// export const previewFiles = (url) => {
//   if (!url) return null;

//   const fileExtension = url.split('.').pop().toLowerCase();
//   const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'png'].includes(fileExtension);
//   const isPDF = fileExtension === 'pdf';

//   if (isImage) {
//     return <img className="pastImage" src={url} alt="attachment preview" />;
//   } else if (isPDF) {
//     return <BsFilePdf size={50} color="red" />;
//   } else {
//     return <p>Unsupported file type</p>;
//   }
// };
// //-------------reply-preview-only-file---image-or-pdf-----------------
// export const renderReplyAttachment = (url) => {
//   if (!url) return null
//   const fileExtension = url?.split(".").pop().toLowerCase();
//   const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(fileExtension);
//   const isPDF = fileExtension === "pdf";

//   if (isImage) {
//     return (
//       <img
//         src={url}
//         alt="reply"
//         style={{
//           maxWidth: "100px",
//           borderRadius: "6px",
//           marginTop: "4px",
//           cursor: "pointer",
//         }}
//       // onClick={() => handleViewProfile(file.url)}
//       />
//     );
//   } else if (isPDF) {
//     return (
//       <div
//         // onClick={() => handleViewProfile(file.url)}
//         style={{ marginTop: "5px", cursor: "pointer" }}
//       >
//         <BsFilePdf size={30} color="red" title="PDF Preview" />
//       </div>
//     );
//   }

//   return (
//     <div style={{ fontSize: "0.8em", color: "#999" }}>
//       Unsupported attachment
//     </div>
//   );
// };

export const havePermission = (admins, user) => {
  let permission = false;

  for (let admin of admins) {
    if (admin.role === "ADMIN" && admin._user?._id === user?._id) {
      permission = true;
      break;
    }
  }

  return permission;
}

// verify email
export const verifyEmail = (value) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

  return emailRegex.test(value);
};

// this function is used to get arrays of counts
export function countArray(limit = 0) {
  let arr = [];
  for (let i = 1; i <= limit; i++) {
    arr.push(i);
  }
  return arr;
}

// accept number only
export const provideOnlyNumbers = (value) => {
  return value.replace(/\D/g, "");
};

export function timeAgo(date) {
  const now = new Date();
  const diff = now - new Date(date);

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const weeks = Math.floor(days / 7);
  const months = Math.floor(days / 30);
  const years = Math.floor(days / 365);

  if (years > 0) {
    return years === 1 ? `1 year ago` : years + ` years ago`;
  } else if (months > 0) {
    return months === 1 ? `1 month ago` : months + ` months ago`;
  } else if (weeks > 0) {
    return weeks === 1 ? `1 week ago` : weeks + ` weeks ago`;
  } else if (days > 0) {
    return days === 1 ? `1 day ago` : days + ` days ago`;
  } else if (hours > 0) {
    return hours === 1 ? `1 hour ago` : hours + ` hours ago`;
  } else if (minutes > 0) {
    return minutes === 1 ? `1 minute ago` : minutes + ` minutes ago`;
  } else {
    return seconds < 10 ? `just now` : seconds + ` seconds ago`;
  }
}

export function groupBy(array, key) {
  let getTimestamp = (str) => +new Date(...str.split("-").reverse());
  const arr = array.reduce((acc, obj) => {
    const property = moment(obj[key]).format("DD-MM-YYYY");
    acc[property] = acc[property] || [];
    acc[property].push(obj);
    return acc;
  }, {});
  let completeArr = [];
  for (let a in arr) {
    completeArr.push({ date: a, data: arr[a] });
  }
  return completeArr
    .sort((a, b) => getTimestamp(a.date) - getTimestamp(b.date))
    .reverse();
}
